import { Recommends, Cards } from '../types';

const parseProfessions = (data: Recommends): Cards => {
  return data.length
    ? data.map((item: any) => ({
        id: item.id,
        title: item.name,
        img: {
          large: item.image_src_big,
          small: item.image_src_little,
        },
        to: {
          name: 'profession',
          params: { id: item.id },
        },
      }))
    : [];
};

const parseCompetences = (data: Recommends): Cards => {
  return data.length
    ? data.map((item: any) => ({
        id: item.id,
        title: item.name,
        img: {
          large: item.image_src_big,
          small: item.image_src_little,
        },
        to: {
          name: 'competence',
          params: { id: item.id },
        },
      }))
    : [];
};

const parsePrograms = (data: Recommends): Cards => {
  return data.length
    ? data.map((item: any) => ({
        id: item.id,
        title: item.full_name,
        img: {
          large: item.image_src_big,
          small: item.image_src_little,
        },
        to: {
          name: 'event-card',
          params: { id: item.id },
        },
      }))
    : [];
};

const parseVacancies = (data: Recommends): Cards => {
  return data?.length
    ? data.map((item: any) => ({
        id: item.id,
        title: item.name,
        img: {
          large: item.image_src_big,
          small: item.image_src_little,
        },
        to: {
          name: 'vacancy',
          params: { id: item.id },
        },
      }))
    : [];
};

const parseEmployers = (data: Recommends): Cards => {
  return data.length
    ? data.map((item: any) => ({
        id: item.id,
        title: item.name,
        img: {
          large: item.image_src_big,
          small: item.image_src_little,
        },
        to: {
          name: 'employer_partners',
          params: { id: item.id },
        },
      }))
    : [];
};
const parseContractorPartners = (data: Recommends): Cards => {
  return data.length
    ? data.map((item: any) => ({
        id: item.id,
        title: item.name,
        img: {
          large: item.image_src_big,
          small: item.image_src_little,
        },
        to: {
          name: 'contractor_partners',
          params: { id: item.id },
        },
      }))
    : [];
};
export {
  parsePrograms,
  parseProfessions,
  parseCompetences,
  parseVacancies,
  parseEmployers,
  parseContractorPartners,
};



// WEBPACK FOOTER //
// ./src/services/smart/utils/parsePrograms.ts